/**
 * TODO(cochamberlain): Separate these into some natural structure.
 */

import { AppState } from "../types";

export const getVersions = (state: AppState) => {
  return state.entities.versions;
};

/** Returns current kernel id url (i.e. "username/notebook-title"). */
export const getKernelIdPath = (state: AppState) => state.notebook.kernelIdPath;

export const addLeadingSlashIfMissing = (kernelIdUrl: string) => {
  if (kernelIdUrl.startsWith("/")) {
    return kernelIdUrl;
  } else {
    return "/" + kernelIdUrl;
  }
};
